import _taggedTemplateLiteral from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import React from "react";
import { Experiment, SOURCE_TYPE_PRODUCT_PAGE_PERSONALISED_RECOMMENDER, SOURCE_TYPE_PRODUCT_PAGE_RECOMMENDER_BI_EVENTS_V2 } from "@catchoftheday/analytics";
import { Box } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";
import { isSoldByCatch } from "@catchoftheday/utilities";
import { PERSONALISED_PRODUCT_RECOMMENDER_EXPERIMENT, SIMILAR_PRODUCT_RECOMMENDER_EXPERIMENT } from "@personalisation/consts";
import { BrandRecommendedProducts } from "../BrandRecommendedProducts";
import { PeopleAlsoViewed } from "../PeopleAlsoViewed";
import { PersonalisedProductRecommender } from "../PersonalisedProductRecommender";
import { RecommendedEvents } from "../RecommendedEvents";
import { SimilarProducts } from "../SimilarProducts";
import { showRecommenderForBrandSlug, showRecommenderForSellerId } from "../utils";
import { jsx as ___EmotionJSX } from "@emotion/react";
var RecommenderWrapper = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  > div:nth-of-type(even) {\n    background: ", ";\n  }\n  > div:nth-of-type(odd) {\n    background: white;\n  }\n  clear: both;\n  overflow: hidden;\n"])), themeGet("ui.backgroundColor"));
export var RecommenderContainer = function RecommenderContainer(_ref) {
  var _offer$seller, _offer$seller2, _offer$seller3;

  var brand = _ref.brand,
      offer = _ref.offer,
      productId = _ref.productId,
      adult = _ref.adult,
      fromProduct = _ref.fromProduct,
      sourceId = _ref.sourceId;
  var isBrandRestrictedRecommender = brand && isSoldByCatch(offer === null || offer === void 0 ? void 0 : (_offer$seller = offer.seller) === null || _offer$seller === void 0 ? void 0 : _offer$seller.id) && showRecommenderForBrandSlug(brand.slug);
  var isSellerRestrictedRecommender = (offer === null || offer === void 0 ? void 0 : offer.seller) && showRecommenderForSellerId(offer === null || offer === void 0 ? void 0 : (_offer$seller2 = offer.seller) === null || _offer$seller2 === void 0 ? void 0 : _offer$seller2.id);
  var isRestrictedRecommender = isBrandRestrictedRecommender || isSellerRestrictedRecommender;
  return ___EmotionJSX(RecommenderWrapper, null, isRestrictedRecommender && brand && ___EmotionJSX(BrandRecommendedProducts, {
    productIds: [productId],
    brandName: brand.name,
    sellerName: isSellerRestrictedRecommender ? offer === null || offer === void 0 ? void 0 : (_offer$seller3 = offer.seller) === null || _offer$seller3 === void 0 ? void 0 : _offer$seller3.name : undefined,
    fromProduct: fromProduct,
    sourceId: sourceId
  }), !isRestrictedRecommender && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(PeopleAlsoViewed, {
    productIds: [productId],
    adult: adult,
    fromProduct: fromProduct,
    sourceId: sourceId
  }), ___EmotionJSX(Experiment, {
    experiment: SIMILAR_PRODUCT_RECOMMENDER_EXPERIMENT
  }, function (exp) {
    return (exp === null || exp === void 0 ? void 0 : exp.active) && ___EmotionJSX(SimilarProducts, {
      productId: productId,
      adult: adult,
      fromProduct: fromProduct,
      experimentBucket: exp.bucket,
      sourceId: sourceId
    });
  }), ___EmotionJSX(RecommendedEvents, {
    productIds: [productId],
    sourceType: SOURCE_TYPE_PRODUCT_PAGE_RECOMMENDER_BI_EVENTS_V2,
    fromProduct: fromProduct,
    sourceId: sourceId
  }), ___EmotionJSX(Experiment, {
    experiment: PERSONALISED_PRODUCT_RECOMMENDER_EXPERIMENT
  }, function (exp) {
    return (exp === null || exp === void 0 ? void 0 : exp.bucket) === 1 ? ___EmotionJSX(PersonalisedProductRecommender, {
      adult: adult,
      fromProduct: fromProduct,
      sourceId: sourceId,
      sourceType: SOURCE_TYPE_PRODUCT_PAGE_PERSONALISED_RECOMMENDER
    }) : null;
  })));
};